// LOS STATUS DE RENOVACIÓN: los de fábrica y los que cada agencia se inventa.
//
// Vivían dentro de deskte-full.jsx, en la pantalla de Renovaciones. Salen aquí
// (Lissette, 2026-11-04: *"en el dashboard de reporte poder tener reportes del
// módulo de renovación con los status de renovación, tanto los que están como
// los que las personas hacen personalizados; también en reporte de clientes"*)
// para que Renovaciones, los Paneles de Reportes y el Reporte de Clientes
// digan el MISMO nombre y el MISMO color para cada status.
//
// El id LISTA_SOMETER es ESPEJO de `ETAPA_LISTA_PARA_SOMETER` en
// deskte-api/src/utils/chatBot.ts, y los nombres en español son espejo de
// `ETAPAS_DE_FABRICA` en deskte-api/src/utils/etapaDeRenovacion.ts. Hay
// pruebas que fallan si se separan.
//
// Los propios de la agencia se guardan en AgencySetting.renewalStatuses como
// [{ id: "cs_…", label, color }].

export const DEFAULT_RENEWAL_STATUSES = [
  { id:"PROCESO",        es:"En proceso",        en:"In progress",     color:"#3b82f6" },
  { id:"REVISION",       es:"En revisión",       en:"In review",       color:"#a855f7" },
  { id:"LISTA_SOMETER",  es:"Lista para someter",en:"Ready to submit", color:"#14b8a6" },
  { id:"SOMETIDA",       es:"Sometida",          en:"Submitted",       color:"#f59e0b" },
  { id:"DONE",           es:"Lista",             en:"Done",            color:"#10b981" },
  // Sale de Pendientes y pasa a su propia pestaña (Lissette 2026-09-29). El id
  // es ESPEJO de ETAPA_NO_RENUEVA en crm-app/utils.js.
  { id:"NO_RENUEVA",     es:"No va a renovar",   en:"Not renewing",    color:"#ef4444" },
];

/** Todos los status, de fábrica primero y luego los de la agencia: [{ id, label, color, builtin }]. */
export function todosLosEstatusDeRenovacion(propias, lang = 'es') {
  const es = lang === 'es';
  const base = DEFAULT_RENEWAL_STATUSES.map((s) => ({ id: s.id, label: es ? s.es : s.en, color: s.color, builtin: true }));
  const extra = (Array.isArray(propias) ? propias : [])
    .filter((s) => s && s.id && s.label)
    .map((s) => ({ id: s.id, label: String(s.label), color: s.color || '#64748b', builtin: false }));
  return [...base, ...extra];
}

/**
 * El nombre de un status. Uno que la agencia ya borró se queda con su id:
 * mejor algo que nada (igual que nombreDeEtapa en el servidor).
 */
export function nombreDeEstatusDeRenovacion(id, propias, lang = 'es') {
  const k = String(id ?? '').trim();
  if (!k) return '';
  const hit = todosLosEstatusDeRenovacion(propias, lang).find((s) => s.id === k);
  return hit ? hit.label : k;
}

// LOS PROPIOS DE LA AGENCIA, A MANO PARA TODA LA APP.
//
// Los Paneles de Reportes ponen nombre a cada barra con `etiquetaDe`, que se
// llama desde muchos sitios. En vez de pasar la lista por todos ellos, la app
// la apunta aquí al leer los ajustes de la agencia y cada vez que Renovaciones
// la cambia — igual que las preferencias de fecha y de nombre (utils.js).
let propiasDeLaAgencia = [];

export function recordarEstatusPropiosDeRenovacion(lista) {
  propiasDeLaAgencia = Array.isArray(lista) ? lista.filter((s) => s && s.id && s.label) : [];
}

export const estatusPropiosDeRenovacion = () => propiasDeLaAgencia;
